// Movie Genres from uNoGS API
export const movieGenres = [
  {
    id: '0',
    en: 'All Genres',
    de: 'Alle Genres',
    es: 'Todos los géneros',
    pt: 'Todos os géneros',
    tr: 'Tüm türler'
  },
  {
    id: '899,9584,10702,27756,30140,43048,46576,90176,801362',
    en: 'Action & Adventure',
    de: 'Aktion & Abenteuer',
    es: 'Acción y aventuras',
    pt: 'Ação e aventura',
    tr: 'Eylem ve macera'
  }, // Critically-acclaimed Action & Adventure
  {
    id: '3063,10695,2316199,7424,1433679',
    en: 'Anime',
    de: 'Animé',
    es: 'Anime',
    pt: 'Anime',
    tr: 'Animé'
  }, // Anime Movies, Anime Horror Films, Anime based on Comics, Anime Sci-Fi & Fantasy
  {
    id: '783,31901,51058,52847,52855,2245805',
    en: 'Children & Family',
    de: 'Kinder & Familie',
    es: 'Niños y familia',
    pt: 'Crianças e família',
    tr: 'Çocuklar ve aile'
  }, // Children & Family Films
  {
    id: '9736,11559,43040,52847',
    en: 'Comedies',
    de: 'Komödien',
    es: 'Comedias',
    pt: 'Comédias',
    tr: 'Komediler'
  }, // Critically Acclaimed Comedies, Stand-up Comedy
  {
    id: '5824,6889,9584,10499,788212',
    en: 'Crime',
    de: 'Krimi',
    es: 'Crimen',
    pt: 'Crime',
    tr: 'Suç'
  }, // Crime Films
  {
    id: '6839,180,1159,3652,5349,9875',
    en: 'Documentaries',
    de: 'Dokumentarfilme',
    es: 'Documentales',
    pt: 'Documentários',
    tr: 'Belgeseller'
  },
  {
    id: '5763,384,794,3682,4961',
    en: 'Dramas',
    de: 'Dramen',
    es: 'Dramas',
    pt: 'Dramas',
    tr: 'Dramalar'
  },
  {
    id: '8711,1694,4809,9509,42023',
    en: 'Horror',
    de: 'Horror',
    es: 'Horror',
    pt: 'Horror',
    tr: 'Korku'
  },
  {
    id: '852488,78367,1474327,852492,852493,852490',
    en: 'International',
    de: 'International',
    es: 'International',
    pt: 'International',
    tr: 'International'
  }, // International Thrillers
  {
    id: '52852,1701,13335,52843,84483',
    en: 'Music & Musicals',
    de: 'Musik & Musicals',
    es: 'Música y musicales',
    pt: 'Música e musicals',
    tr: 'Müzik ve musicals'
  },
  {
    id: '29281,3830,35800,36103,53915',
    en: 'Romantic',
    de: 'Romantisch',
    es: 'Romántico',
    pt: 'Romântico',
    tr: 'Romantik'
  }, // Steamy Romantic Films
  {
    id: '1492,1568,3327,3916,6926,11014,9744,90166',
    en: 'Sci-Fi & Fantasy',
    de: 'Sci-Fi & Fantasy',
    es: 'Sci-Fi & Fantasy',
    pt: 'Sci-Fi & Fantasy',
    tr: 'Sci-Fi & Fantasy'
  },
  {
    id: '4370,180,5286,7243,100446',
    en: 'Sports',
    de: 'Sport',
    es: 'Deportes',
    pt: 'Esportes',
    tr: 'Spor'
  }, // Sports Films
];

// TV Genres from uNoGS API
export const tvGenres = [
  {
    id: '0',
    en: 'All Genres',
    de: 'Alle Genres',
    es: 'Todos los géneros',
    pt: 'Todos os géneros',
    tr: 'Tüm türler'
  },
  {
    id: '6721,9302,11146,413820,1519826,1819776,1819777,2316199,2867624,2913945',
    en: 'Anime',
    de: 'Animé',
    es: 'Anime',
    pt: 'Anime',
    tr: 'Animé'
  }, // "Anime Series"
  {
    id: '1333288,6197,7539,7992,9736,10256,869,1402,4058,89682',
    en: 'Comedies',
    de: 'Komödien',
    es: 'Comedias',
    pt: 'Comédias',
    tr: 'Komediler'
  }, // Goofy Comedies, TV Comedy Dramas,TV Animated Comedies,Critically Acclaimed Comedies,Slapstick Comedies", 10375:"Comedy Programmes", 26049:"Romantic TV Comedies"
  {
    id: '26009,26146',
    en: 'Crime',
    de: 'Krimi',
    es: 'Crimen',
    pt: 'Crime',
    tr: 'Suç'
  }, // Crime TV Dramas
  {
    id: '81562604,180,1159,5349,9875,10105',
    en: 'Docuseries',
    de: 'Dokumentar-Serien',
    es: 'Documentales',
    pt: 'Documentários',
    tr: 'Belgeseller'
  }, // Docuseries
  {
    id: '28083,28034,52843,65925,413820',
    en: 'Kids',
    de: 'Kinder',
    es: 'Niños',
    pt: 'Crianças',
    tr: 'Çocuklar'
  }, // Kids TV for ages 8 to 10
  {
    id: '9833,49266,49296,50103,1023212',
    en: 'Reality TV',
    de: 'Reality TV',
    es: 'Reality TV',
    pt: 'Reality TV',
    tr: 'Reality TV'
  }, // Reality Programmes
  {
    id: '26156,29281,36103,50103,53915,1522234,26056',
    en: 'Romance',
    de: 'Romantisch',
    es: 'Romántico',
    pt: 'Romântico',
    tr: 'Romantik'
  }, // Romance Programmes
  {
    id: '1372,3300242,1002031',
    en: 'Sci-Fi & Fantasy',
    de: 'Sci-Fi & Fantasy',
    es: 'Sci-Fi & Fantasy',
    pt: 'Sci-Fi & Fantasy',
    tr: 'Sci-Fi & Fantasy'
  }, // Sci-Fi & Fantasy Programmes
];
